export const WorkspaceConfig_Advisor = {
    name: 'Advisor',
    key: 'horizontalSpace',
    visible: true,
    factor: 1,
    min: -1,
    data: {
        panels: [
            {
                name: 'LeftPanel', key: 'findingsPanel', visible: true, factor: 1 / 5, min: 100,
                data: {
                    filter: ''
                }
            },
            {
                name: 'centerPanel', key: 'ruleOutPanel', visible: true, factor: 3 / 5, min: 100,
                data: {
                    filter: '',
                    categoryFilter: undefined
                }
            },
            {
                name: 'RightPanel', key: 'pendingPanel', visible: true, factor: 1 / 5, min: 100,
                data: {
                    filter: '',
                }
            },
        ]
    }
};
